const filter = require('./filter');

const split = (operator) => {

  const r = operator.replace(/[\\^$.\-*+?()[\]{}|]/g, '\\$&');
        regexp = new RegExp(`[${r}]$`);

  return (key) => {
    return [key.replace(regexp, ''), (key.match(regexp)) ? key.match(regexp)[0] : '='];
  };

};

module.exports = {
  filter: filter(split)
};
